import {
  FilterOperator,
  OperatorDisplay,
  type OperatorsList
} from '../../types'

export const operators: OperatorsList = {
  string: [
    { operator: FilterOperator.Eq, des: OperatorDisplay.Equals },
    { operator: FilterOperator.Ne, des: OperatorDisplay.NotEquals },
    { operator: FilterOperator.Gt, des: OperatorDisplay.GreaterThan },
    { operator: FilterOperator.Gte, des: OperatorDisplay.GreaterThanOrEqual },
    { operator: FilterOperator.Lt, des: OperatorDisplay.LessThan },
    { operator: FilterOperator.Lte, des: OperatorDisplay.LessThanOrEqual },
    { operator: FilterOperator.REGEX, des: OperatorDisplay.Regex }
  ],
  array: [
    { operator: FilterOperator.In, des: OperatorDisplay.Equals },
    { operator: FilterOperator.Nin, des: OperatorDisplay.NotEquals },
    {
      operator: FilterOperator.Filteraction,
      des: OperatorDisplay.Filteraction
    }
  ]
}
